import { render, staticRenderFns } from "./acts-mode-control.vue?vue&type=template&id=3a0ccf5b"
import script from "./acts-mode-control.vue?vue&type=script&lang=js"
export * from "./acts-mode-control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports